<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <el-button style="margin-bottom: 10px" type="primary" @click="doAdd()">新增统计类型</el-button>
        <zv-table :table="table" ref="dataTable">
        </zv-table>

        <zv-dialog
          width="800px"
          :title="isEdit ? '修改统计类型' : '新增统计类型'"
          :showDialog.sync="showFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="统计类型名称：" prop="type_name">
                <el-input v-model="formData.type_name" placeholder="请输入统计类型" clearable></el-input>
              </el-form-item>
              <el-form-item label="所属事件类型：" prop="risk_id">
                <el-select
                  v-model="formData.risk_id"
                  filterable
                  clearable
                  placeholder="请选择事件类型"
                >
                  <el-option
                    v-for="item in fieldList"
                    :key="item.id"
                    :label="item.risk_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button v-if="isEdit" type="primary" @click="editFormFn">确定</el-button>
            <el-button v-else type="primary" @click="submitFormFn">确定</el-button>
          </div>
        </zv-dialog>

        <!-- 2021.02.02新增弹窗 -->
        <el-dialog
          :title="alertTitle"
          :visible.sync="dialogVisible"
          width="60%"
          @close="closeFormDialog"
          >
          <p>统计数据枚举：</p>
          <div class="enumeration">
            <div class="enumeration_li" v-for="(item,index) in tjArr" :key="index">
              {{item}}
              <span class="el-icon-close" @click="delEnumeration(item)"></span>
            </div>
          </div>
          <div class="input_box">
            <el-input v-model="enumeration_val" placeholder="请输入"></el-input>
            <el-button style="margin-left: 20px" type="primary" @click="addEnumeration">新增</el-button>
          </div>
        </el-dialog>

      </div>
    </div>
  </div>
</template>
<script>
import baseApi from "@/api/baseApi";
import dataAnalysisApi from "@/views/data-analysis/api";
import api from "./api";
import TipUtil from "@/utils/utils/TipUtil";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AppList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.tjList,
        hidePagination: true,
        query: {

        },
        columns: [
          {
            title: "事件类型",
            key: "risk_name",
            minWidth:"100",
            showTooltip: true
          },
          {
            title: "统计类型",
            key: "type_name",
            minWidth:"100",
            showTooltip: true
          },
          {
            title: "统计数据枚举",
            minWidth:"550",
            // showTooltip: true,
            render(h, ctx) {
              return h("span", ctx.row.tj_items+"");
            }
          },
          
         
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEditFn.bind(this, ctx.row)
                  }
                },
                "统计数据枚举编辑"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
      },
      formRules: {
        type_name: {
          required: true,
          message: "字段名不能为空",
          trigger: "blur"
        },
        risk_id: {
          required: true,
          message: "字段类型不能为空",
          trigger: "change"
        }
      },
      fieldList: [
        
      ],
      deleteApi: api.tjDelete,
      addSuccessMsg: '添加采集源成功',
      editSuccessMsg: '编辑采集源成功',
      deleteSuccessMsg: '删除成功',
      addFieldVal: '',
      fieldTagList: [],
      selectVal: '',
      selectValArr: [],
      editId: '',
      isEdit: false,
      dialogVisible: false,
      alertTitle: '',
      tjArr: '',
      enumeration_val: '',
    };
  },

  methods: {
    // 2021.02.02新增风险类型下拉菜单
    riskListFn() {
      api.riskList({
        pagesize: 999
      })
      .then(res => {
        if(res.error_code == 0) {
          this.fieldList = res.list
        }
      })
      .catch(err => {
        // console.log(err);
      });
    },
    addEnumeration() {
      let datas = {
        id: this.editId,
        item_name: this.enumeration_val
      }
      api.tjItemsCreate(datas)
      .then(res => {
        if(res.error_code == 0) {
          this.enumeration_val = ""
          this.enumerationInfo()
        }
      })
      .catch(err => {
        // console.log(err);
      });
    },
    // 删除枚举字段
    delEnumeration(name) {
      let datas = {
        id: this.editId,
        item_name: name
      }
      api.tjItemsDelete(datas)
      .then(res => {
        if(res.error_code == 0) {
          this.enumerationInfo()
        }
      })
      .catch(err => {
        // console.log(err);
      });
    },
    closeFormDialog() {
      this.$refs.dataTable.refresh()
    },
    submitFormFn() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          api
          .tjCreate(this.formData)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("新增成功!")
              this.showFormDialog = false
              this.$refs.dataTable.refresh()
            }
          })
          .catch(err => {
            // console.log(err);
          });
        } else {
          
        }
      });
    },
    enumerationInfo() {
      api.tjInfo({
        id: this.editId
      })
      .then(res => {
        if(res.error_code == 0) {
          this.tjArr = res.info.tj_items
        }
      })
      .catch(err => {
        // console.log(err);
      });
    },
    doEditFn(rows) {
      this.dialogVisible = true
      this.editId = rows.id
      this.alertTitle = rows.risk_name + '-' + rows.type_name
      this.tjArr = rows.tj_items
    }
  },

  created() {
    this.riskListFn()
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>
  .field_li {
    position: relative;
    float: left;
    padding: 0px 8px;
    margin: 0 5px;
    border: 1px solid #DCDFE6;
    .field_li_icon {
      position: absolute;
      right: 0px;
      top: 0px;
      cursor: pointer;
    }
  }
  .enumeration {
    display: flex;
    width: 100%;
    min-height: 40px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    // justify-content: space-between;
    // background: red;
    .enumeration_li {
      display: inline-block;
      padding: 5px 10px;
      border: 1px solid #DCDFE6;
      margin-left: 15px;
      margin-top: 15px;
      span {
        cursor: pointer;
      }
      &:nth-of-type(1) {
        // margin-left: 0;
      }
    }
  }
  .input_box {
    display: flex;
    width: 200px
  }
</style>
